function EditIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="15"
			fill="none"
			viewBox="0 0 14 15"
		>
			<path
				fill="#1F8268"
				d="M1.75 10.785v1.773c0 .164.128.292.292.292h1.773c.076 0 .152-.03.204-.087l6.37-6.365-2.187-2.187-6.364 6.364a.286.286 0 00-.088.21zm10.33-6.078a.58.58 0 000-.823L10.717 2.52a.58.58 0 00-.823 0L8.826 3.587l2.187 2.187 1.068-1.067z"
			/>
		</svg>
	);
}

export default EditIcon;
